module.exports = __webpack_public_path__ + "static/media/app-get-ios.7be5a227.png";